export default "__VITE_ASSET__DY2UMELT__"